import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllServices } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useDeleteAllServices = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllSer,
        isPending: isDeleteAll,
    } = useMutation({
        mutationFn: deleteAllServices,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete services");
        },
    });

    return {
        deleteAllSer,
        isDeleteAll,
    };
};

export default useDeleteAllServices;
